<template>
  <v-container class="dialog-container">
    <v-dialog content-class="tabular-dialog" :value="value" @input="$emit('input', $event)" persistent>
      <v-card :height="totalCardHeight" class="card-background">
        <v-layout style="flex-direction: column;">
          <v-flex style="flex: 0 0 64px;">
            <v-toolbar dark color="primary">
              <v-toolbar-title>{{ title }}</v-toolbar-title>
              <v-spacer />
              <v-btn icon @click="close()" dark>
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-flex style="flex: 1 1 0%; min-width: 0; min-height: 0;">
              <v-layout style=" height: 100%;">
                <v-flex xs2 class="card-bg-2 divider-right" :style="`flex: 0 1 ${configColumnMaxLengthPixels}px; min-height: 0; min-width: 200px; display: flex; flex-direction: column;`">
                  <!-- Will implement side bar in the future -->
                  <!-- <v-flex class="px-2"
                    style="flex: 0 0 57px; background-color: white; border-bottom: 1px solid #e5e5e5; min-width: 0;">
                    <v-text-field v-model="search" append-icon="search" hide-details full-width label="Search Variables"
                      clearable />
                  </v-flex> -->
                  <!-- <v-btn @click="saveFlags">Submit</v-btn>
                  {{ menu.datum }} -->
                  <v-container style="overflow: auto; height: 100%;">
                    <template v-if="loading">
                      <v-list style="background-color: transparent">
                        <div class="subheading">Flags</div>
                        <template v-for="index in 2">
                          <v-list-tile :key="index">
                            <v-list-tile-content>
                              <v-list-tile-title class="loading-skeleton-1">
                                {{ index }} -
                                <small>{{ index }}</small>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </template>
                    <template v-else>
                      <v-list style="background-color: transparent">
                        <div class="subheading">Flags</div>
                        <template v-for="(item, i) in selectFlags">
                          <v-list-tile :key="i">
                            <v-list-tile-content style="display: flex;">
                              <v-list-tile-title class="flags">
                                {{ item.FlagCode }} -
                                <small>
                                  {{ item.Description }}
                                  <span v-if="!item.ShowValues && !showAllValues">(excluded)</span>
                                </small>
                              </v-list-tile-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </template>
                      </v-list>
                    </template>
                    <v-divider></v-divider>
                    <v-list style="background-color: transparent" subheader>
                      <div class="subheading mt-2">Settings</div>
                      <v-switch :disabled="componentIsLoading" hide-details :value="showAllValues" @change="$emit('update-show-all-values', $event || false)" label="Show values hidden by flags">
                      </v-switch>
                    </v-list>
                  </v-container>
                </v-flex>
                <v-flex style="flex: 1 0; min-width: 0; display: flex; overflow-x: scroll;" class="divider-bottom">
                  <VirtualScrollTable :headers="headers" :isLoading="componentIsLoading" :items="collectionItems" :sort="sort" ref="dataTable" @resize="onResize" :optimalHeight="dataTableHeight" :disableSlicedHeaders="true" @click="showItemMenu">
                    <template v-slot:default="slotProps">
                      <SurveyTabularCell class="cell" :header="slotProps.header" :data="slotProps.row.data" :isEditing="isEditing" />
                    </template>
                    <template v-slot:no-data>
                      <v-alert :type="tableAlertType" :value="showTableAlert">
                        {{tableAlertMessage}}
                      </v-alert>
                    </template>
                  </VirtualScrollTable>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-card-actions class="card-bg-2">
          <v-spacer />
          <template v-if="!isEditing">
            <v-btn small color="warning" @click="updateIsEditing(true)" v-if="isTenantAdmin">Edit</v-btn>
          </template>
          <template v-else>
            <v-btn small color="primary" @click="saveFlags">Done</v-btn>
          </template>
          <v-btn small depressed @click="close()">{{ $t('Button.Close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-menu data-ui-component="tabular-flags-dropdown" v-model="menu.flags.show" :position-x="menu.flags.x" :position-y="menu.flags.y" absolute offset-y z-index="212" :close-on-content-click="false">
      <v-list dense>
        <v-list-tile v-for="(item, index) in menu.flags.items" :key="`flag-option-${index}`">
          <v-list-tile-action>
            <v-checkbox v-model="menu.datum.Data.UpdatedFlags" :value="item.FlagCode" :label="item.FlagText" />
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script>
  import VirtualScrollTable from '@/components/generic/VirtualScroll/VirtualScrollTable'
  import virtualList from 'vue-virtual-scroll-list'
  import VirtualCollectionUtil from '@/components/mixins/VirtualCollectionUtil'

  import MomentUtil from '@/components/mixins/MomentUtil'

  import SurveyTabularCell from '@/components/MonitoringFeature/DataSources/SurveyEnvirodata/TabularView/SurveyTabularCell'
  import {
    dataAggregationTypes,
  } from '@/components/MonitoringFeature/DataSources/SurveyEnvirodata/surveyAggregation'

  import {
    arraysEqual,
  } from '@/helpers/arrays'

  const ConfigColumnMaxLengthPixels = 200
  const CardHeightRatio = 0.9
  const ToolbarHeight = 56
  const TableAlertHeight = 77.75
  const TableHeaderHeight = 56
  const CardActionsHeight = 44

  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const flags = createNamespacedHelpers('flags')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    components: {
      SurveyTabularCell,
      VirtualList: virtualList,
      VirtualScrollTable,
    },
    mixins: [VirtualCollectionUtil, MomentUtil],
    props: {
      value: {
        type: Boolean,
        required: true,
      },
      collectionItems: {
        type: Array,
        default: () => [],
      },
      headers: {
        type: Array,
        default: () => [],
      },
      startDate: {
        type: [String, Date],
        default: null,
      },
      endDate: {
        type: [String, Date],
        default: null,
      },
      hasQueriedAggregateData: {
        type: Boolean,
        default: false,
      },
      isEditing: {
        type: Boolean,
        default: false,
      },
      showAllValues: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialog: false,
        search: '',
        // collectionItems: [],
        dateFormat: 'MMM DD, YYYY',
        slowMode: true,
        sort: {
          active: null,
          descending: false,
        },
        selected: {},
        isLoadingComponentSize: false,
        isSavingFlags: false,
        dbitems: Array.from({
          length: 1000,
        }, (_, index) => ({
          data: '#' + index,
        })),
        dataAggregationTypes: dataAggregationTypes,
        configColumnMaxLengthPixels: ConfigColumnMaxLengthPixels,
        // totalCardWidth is not computed
        // because 
        totalCardWidth: ConfigColumnMaxLengthPixels,
        windowHeight: window.innerHeight,
        menu: {
          datum: {
            Data: {
              flags: [],
            },
          },
          flags: {
            show: false,
            x: 0,
            y: 0,
            items: [], // FIXME
          },
        },
      }
    },
    computed: {
      ...flags.mapGetters(['flags']),
      ...authenticate.mapGetters(['currentTenant', 'isTenantAdmin']),
      totalCardHeight() {
        return this.windowHeight * CardHeightRatio
      },
      dataTableHeight() {
        const pad = 0
        const tableHeightWithoutAlert = this.totalCardHeight - ToolbarHeight - TableHeaderHeight - CardActionsHeight -
          pad
        return this.showTableAlert ? tableHeightWithoutAlert - TableAlertHeight : tableHeightWithoutAlert
      },
      title() {
        let titleText = 'Tabular View'
        if (this.startDate != null && this.startDate != '' && this.endDate != null && this.endDate != '') {
          return `${titleText} - ${this.formatDate(this.startDate, this.dateFormat)} to ${this.formatDate(this.endDate, this.dateFormat)}`
        }
        return titleText
      },
      tableAlertType() {
        return this.hasQueriedAggregateData ? 'info' : 'warning'
      },
      tableAlertMessage() {
        return this.hasQueriedAggregateData ? 'Data with a single measurement do not have aggregate data' :
          'Query returned no data'
      },
      selectFlags() {
        return this.flags.map(flag => {
          return {
            ...flag,
            FlagText: `${ flag.FlagCode } - ${ flag.Description }`,
          }
        })
      },
      componentIsLoading() {
        return this.loading || this.isLoadingComponentSize || this.isSavingFlags
      },
      hasNoData() {
        return this.collectionItems.length == 0
      },
      showTableAlert() {
        return (this.hasNoData || this.hasQueriedAggregateData) && !this.componentIsLoading
      },
    },
    watch: {
      collectionItems() {
        this.initializeUI()
        this.onResize()
      },
      selectFlags: {
        immediate: true,
        handler(value) {
          this.menu.flags.items = value
        },
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...flags.mapActions(['getFlagsByTenant']),
      onSlice() {},
      onSort() {},
      onResize(dataTableWidthPixels = null) {
        if (dataTableWidthPixels == null) {
          dataTableWidthPixels = (this.$refs.dataTable && this.$refs.dataTable.dom.totalWidth) ||
            ConfigColumnMaxLengthPixels
        }
        const pad = 100
        this.totalCardWidth = this.configColumnMaxLengthPixels + dataTableWidthPixels + pad
      },
      cellSizeAndPositionGetter2(item, index) {
        // compute size and position
        return {
          width: 100,
          height: 150,
          x: (index % 2) * 110,
          y: parseInt(index / 2) * 160,
        }
      },
      isActiveSort() {
        return false
      },
      close() {
        this.updateIsEditing(false)
        this.$emit('input', false)
      },
      generateItemId(x) {
        return `${x.Key}__${x.Data.VariableName}`
      },
      makeCollectionItems() {
        let items = this.data
        let that = this

        this.collectionItems = items.map(x => {
          let hasReplicates = x.Data.Values.length > 1
          let dataValue = hasReplicates ?
            that.makeCollectionItemsWithReplicates(x.Data) :
            that.makeCollectionItemsNoReplicates(x.Data)
          let res = {
            data: {
              selected: x.selected,
              Id: this.generateItemId(x),
              Key: x.Key,
              Data: {
                ...dataValue,
              },
            },
          }
          return res
        }).filter(x => x.data.Data.VariableName != null)
      },
      makeCollectionItemsNoReplicates(data) {
        if (data.Values.length == 0) {
          return null
        }
        let dataValue = data.Values[0]
        return {
          VariableName: data.VariableName,
          Value: dataValue.Value,
          ValueType: dataValue.ValueType,
          PeripheralData: dataValue.PeripheralData || {},
          Comment: dataValue.Comment,
          Flags: dataValue.Flags || [],
          AggregateValues: {},
        }
      },
      makeCollectionItemsWithReplicates(data) {
        if (data.Values.length == 0) {
          return null
        }
        const hasMixedTypes = data.HasMixedTypes || false
        const values = data.Values.map(x => x.Value)
        const valueType = hasMixedTypes ? 'Mixed' : data.Values[0].ValueType
        return {
          VariableName: data.VariableName,
          Value: values,
          ValueType: valueType,
          PeripheralData: data.AggregateValues.PeripheralData || {},
          Flags: [],
          AggregateValues: data.AggregateValues.Values || {},
        }
      },
      initializeUI() {
        this.isLoadingComponentSize = true
        this.updateMaxWidths(this.headers, this.collectionItems)
        this.isLoadingComponentSize = false
      },
      setupRows(items) {
        items.forEach(item => {
          this.$set(this.selected, this.generateItemId(item), {
            value: false,
            reference: item,
          })
        })
      },
      showItemMenu(event) {
        let cellInfo = this._showItemMenu_traverseParentToFindCellType(event.target)
        let datum = null
        let menuState = null
        switch (cellInfo.cellType) {
        case 'cellFlags':
          datum = this._showItemMenu_searchItem(cellInfo.cellId)
          menuState = this.menu.flags
          break
        }
        if (menuState != null && datum != null) {
          this.menu.datum = datum
          this._showItemMenu_setMenuSettings(menuState, event)
          menuState.show = true
        }
      },
      _showItemMenu_traverseParentToFindCellType(element) {
        let itemId = null
        while (element && !itemId) {
          if (!element.id) {
            element = element.parentElement
            continue
          }
          let cellInfo = this._showItemMenu_parseCellId(element.id)
          if (cellInfo == null) {
            return null
          }
          if (cellInfo.cellType == null || cellInfo.cellId == null) {
            return null
          }
          return cellInfo
        }
      },
      _showItemMenu_parseCellId(componentId) {
        let componentIdParts = componentId && componentId.split('-')
        let cellType = componentIdParts && componentIdParts.length > 0 && componentIdParts[0]
        let cellId = componentIdParts && componentIdParts.length > 1 && componentIdParts[1]
        if (cellType == null || !cellType.includes('cell')) {
          return null
        }
        return {
          cellType,
          cellId,
        }
      },
      _showItemMenu_setMenuSettings(menuState, event) {
        if (menuState == null) {
          return
        }
        menuState.x = event.clientX
        menuState.y = event.clientY
      },
      _showItemMenu_searchItem(cellId) {
        let item = this.collectionItems.find(x => x.data.Id == cellId)
        return item && item.data
      },
      fetchFlagsIfNeeded() {
        if (this.flags.length != 0) {
          return
        }
        let roleMapId = this.currentTenant && this.currentTenant.id
        if (roleMapId == null) {
          return
        }
        this.getFlagsByTenant(roleMapId)
      },
      async saveFlags() {
        const updatedDatumList = this.getDatumWithUpdatedFlags()
        const updateFlagRequest = this.createUpdateFlagRequests(updatedDatumList)
        try {
          this.isSavingFlags = true
          await this.axios.put('api/Surveys/Metadata/Flag', updateFlagRequest)
          this.emitRefreshData()
          this.updateIsEditing(false)
        } catch (err) {
          console.error(err)
          this.setSnackbar({
            icon: 'error',
            color: 'error',
            text: err,
          })
        } finally {
          this.isSavingFlags = false
        }
      },
      emitRefreshData() {
        this.$emit('refresh')
      },
      getDatumWithUpdatedFlags() {
        return this.collectionItems.filter(row => {
          const data = row.data.Data
          let originalFlagIds = (data.OriginalFlags && data.OriginalFlags.map(f => f.Id)) || []
          let updatedFlagIds = (data.UpdatedFlags && data.UpdatedFlags.map(flagCode => {
            let actualFlag = this.flags.find(x => x.FlagCode == flagCode)
            return actualFlag && actualFlag.Id
          })) || []
          return !arraysEqual(originalFlagIds, updatedFlagIds)
        })
      },
      createUpdateFlagRequests(updatedDatum) {
        return updatedDatum.map(row => {
          const data = row.data.Data
          return {
            PairId: data._Trace.KVPairId,
            Flags: data.UpdatedFlags.map(flagCode => {
              let actualFlag = this.flags.find(x => x.FlagCode == flagCode)
              return {
                Id: actualFlag && actualFlag.Id,
              }
            }).filter(x => x.Id != null),
          }
        })
      },
      updateIsEditing(val) {
        this.$emit('update:isEditing', val)
      },
    },
    created() {
      this.initializeUI()
      this.fetchFlagsIfNeeded()
    },
    mounted() {
      this.$nextTick(() => {
        window.addEventListener('resize', () => {
          this.windowHeight = window.innerHeight
        })
        this.initializeUI()
      })

    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeListener)
    },

  }
</script>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter,
  .fade-leave-to

  /* .fade-leave-active below version 2.1.8 */
    {
    opacity: 0;
  }

  .card-background {
    background-color: #f3f3f3;
  }

  .loading-skeleton-1 {
    background-color: #f3f3f3;
    color: transparent;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    -khtml-user-select: none;
    /* Konqueror HTML */
    -moz-user-select: none;
    /* Old versions of Firefox */
    -ms-user-select: none;
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */

    background: linear-gradient(278deg, #f3f3f3, #aaaaaa);
    background-size: 400% 400%;

    -webkit-animation: gradientanimation 10s ease infinite;
    -moz-animation: gradientanimation 10s ease infinite;
    animation: gradientanimation 10s ease infinite;
  }

  @-webkit-keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }

  @-moz-keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }

  @keyframes gradientanimation {
    0% {
      background-position: 0% 31%;
    }

    50% {
      background-position: 100% 70%;
    }

    100% {
      background-position: 0% 31%;
    }
  }

  .virtual-collection-flex {
    flex-grow: 1;
    border: 1px solid #dddddd;
    border-top: none;
    border-right: none;
  }

  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    height: 100%;
    transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
    will-change: background;
    margin-bottom: -2px;
  }

  .rowHeader {
    border-bottom: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
  }

  .row-selected {
    background: #f5f3ff;
  }

  .cell-container hr {
    border-color: transparent;
  }

  .cell {
    text-align: center;
    font-weight: 400;
    font-size: 13px;
    display: flex;
    flex-shrink: 0;
    flex-grow: 0;
    position: relative;
    align-items: center;
    justify-content: center;
  }

  .flex-align-center {
    display: flex;
    align-items: center;
    max-width: 100%;
    justify-content: center;
  }

  table {
    height: 100%;
    width: 100%;
  }

  table tbody {
    width: 100%;
    height: 100%;
  }

  .flags {
    height: auto;
    line-height: inherit;
    white-space: normal;
  }



  .tabular-card {
    width: 100% !important;
  }
</style>

<style>
  .tabular-dialog {
    overflow: hidden !important;
  }
</style>